'use client'

import { IconButton } from '@dafiti/closet-ui'
import { Close, Hamburguer } from '@dafiti/closet-ui/icons'

import { useMenuStore } from '../../../store/menu.slice'
import { useSearchStore } from '../../../store/search.slice'
import { useMessages } from '../../../i18n/useMessages'
import * as track from '../../../tracking/header'
import { MOBILE_NAVIGATION_MENU_STATE_ID } from '../Menu/MobileNavigationMenuState'

const MenuToggle = () => {
  const isMenuOpen = useMenuStore((state) => state.isOpen)
  const toggleMenu = useMenuStore((state) => state.toggle)
  const closeSearch = useSearchStore((state) => state.closeSearch)
  const t = useMessages()

  const handleClick = () => {
    if (!isMenuOpen) {
      track.hamburguerMenuClick()
      closeSearch()
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      toggleMenu()
      e.preventDefault()
    }
  }

  return (
    <IconButton
      size="md"
      variant="subtle"
      aria-label={isMenuOpen ? t.header.closeMenu : t.header.openMenu}
      className="self-center lg:hidden lg:w-auto"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      asChild
      data-testid="menu-toggle"
    >
      <label htmlFor={MOBILE_NAVIGATION_MENU_STATE_ID}>
        {isMenuOpen ? (
          <Close aria-hidden="true" data-testid="close-icon" />
        ) : (
          <Hamburguer aria-hidden="true" data-testid="hamburguer-icon" />
        )}
      </label>
    </IconButton>
  )
}

export default MenuToggle
